import { render } from "./Presskit.vue?vue&type=template&id=92abac3e"
import script from "./Presskit.vue?vue&type=script&lang=ts"
export * from "./Presskit.vue?vue&type=script&lang=ts"

import "./Presskit.vue?vue&type=style&index=0&id=92abac3e&lang=scss"
script.render = render

export default script